/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EstimatedRevenueDtoPage } from '../../models/estimated-revenue-dto-page';

export interface ListEstimatedRevenues$Params {
  projectId?: string | null;
  budgetIds?: Array<string>;
  wpIds?: Array<string>;
  from?: string | null;
  to?: string | null;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'inflowDate' | '-inflowDate' | 'totalAmount' | '-totalAmount' | 'budget' | '-budget' | 'budgetName' | '-budgetName' | 'project' | '-project' | 'workPackage' | '-workPackage' | 'workPackageName' | '-workPackageName' | 'comment' | '-comment' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listEstimatedRevenues(http: HttpClient, rootUrl: string, params?: ListEstimatedRevenues$Params, context?: HttpContext): Observable<StrictHttpResponse<EstimatedRevenueDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listEstimatedRevenues.PATH, 'get');
  if (params) {
    rb.query('projectId', params.projectId, {});
    rb.query('budgetIds', params.budgetIds, {});
    rb.query('wpIds', params.wpIds, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EstimatedRevenueDtoPage>;
    })
  );
}

listEstimatedRevenues.PATH = '/v0/estimatedRevenue';
